import type { FC } from "react";
import type { MatchStatsComponent } from "@motain/xpa-proto-files-web/lib/types/match_stats";
import { isNonNullable } from "@/types/isNonNullable";
import { isNullable } from "@/types/isNullable";
import { MatchStatsEntry } from "./match-stats-entry/MatchStatsEntry";
import styles from "./MatchStats.module.scss";
import classNames from "classnames";
export const MatchStats: FC<MatchStatsComponent> = (props) => {
  const { title, stats } = props;

  if (isNullable(props)) {
    return null;
  }

  return (
    <article className={styles.container}>
      {isNonNullable(title) && (
        <header className={classNames("title-7-bold", styles.title)}>
          {title}
        </header>
      )}

      {isNonNullable(stats) && (
        <ul className={styles.list}>
          {stats.map((stat) => (
            <MatchStatsEntry key={stat.uiKey} {...stat} />
          ))}
        </ul>
      )}
    </article>
  );
};
